import React, { FunctionComponent } from 'react';
import Button from 'components/UI/V3/Button/Button';
import styles from './IntakeFormSection.module.scss';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons';
import { Img } from 'react-image';
import { useMarketplace } from 'hooks/useMarketplace';

interface IntakeFormSectionProps {
    onSend: () => void;
    onSetup: () => void;
}

export const IntakeFormSection: FunctionComponent<IntakeFormSectionProps> = ({ onSend, onSetup }) => {
    const marketplace = useMarketplace();
    return (
        <div className={styles.intakeFormCard}>
            <div className={styles.content}>
                <div className={styles.textContent}>
                    <h3 className={styles.title}>Intake Form</h3>
                    <p className={styles.description}>
                        Share your intake form link today to connect with clients and efficiently create their profiles.
                    </p>
                    <div className={styles.buttonsContainer}>
                        {marketplace.intakeForm.enabled && (
                            <Button
                                label="Send"
                                onClick={onSend}
                                leftIcon={faPaperPlane}
                                variant="green"
                                size="medium"
                            />
                        )}
                        <Button
                            label="Setup"
                            onClick={onSetup}
                            variant={marketplace.intakeForm.enabled ? 'outlined' : 'black'}
                            size="medium"
                            className={marketplace.intakeForm.enabled ? styles.setupButton : ''}
                        />
                    </div>
                </div>
                <div className={styles.imageContainer}>
                    <Img
                        className={styles.desktopImage}
                        src="/images/forms/intake-banner.png"
                    />
                    <Img
                        className={styles.mobileImage}
                        src="/images/forms/intake-banner-mobile.png"
                    />
                </div>
            </div>
        </div>
    );
};

export default IntakeFormSection;
